import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/trial-balance',
}).lazy(() => import('./trial-balance.lazy').then((d) => d.Route))
